export enum ValuesConfigurationName {
  UI_PRICE = 'UI_PRICE',
  TEA = 'TEA',
  USD_TEA = 'USD_TEA',
}
